import keyBy from 'lodash/keyBy';

import { GlobalAction, AnnotationsState } from '.';

const GET_ANNOTATIONS_START = 'GET_ANNOTATIONS_START';
const GET_ANNOTATIONS_ERROR = 'GET_ANNOTATIONS_ERROR';
const GET_ANNOTATIONS_SUCCESS = 'GET_ANNOTATIONS_SUCCESS';
const ADD_ANNOTATIONS_START = 'ADD_ANNOTATIONS_START';
const ADD_ANNOTATIONS_ERROR = 'ADD_ANNOTATIONS_ERROR';
const ADD_ANNOTATIONS_SUCCESS = 'ADD_ANNOTATIONS_SUCCESS';
const EDIT_ANNOTATIONS_START = 'EDIT_ANNOTATIONS_START';
const EDIT_ANNOTATIONS_ERROR = 'EDIT_ANNOTATIONS_ERROR';
const EDIT_ANNOTATIONS_SUCCESS = 'EDIT_ANNOTATIONS_SUCCESS';
const DELETE_ANNOTATIONS_START = 'DELETE_ANNOTATIONS_START';
const DELETE_ANNOTATIONS_ERROR = 'DELETE_ANNOTATIONS_ERROR';
const DELETE_ANNOTATIONS_SUCCESS = 'DELETE_ANNOTATIONS_SUCCESS';

const GET_TEMPLATES_START = 'GET_TEMPLATES_START';
const GET_TEMPLATES_ERROR = 'GET_TEMPLATES_ERROR';
const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS';
const ADD_TEMPLATES_START = 'ADD_TEMPLATES_START';
const ADD_TEMPLATES_ERROR = 'ADD_TEMPLATES_ERROR';
const ADD_TEMPLATES_SUCCESS = 'ADD_TEMPLATES_SUCCESS';
const EDIT_TEMPLATES_START = 'EDIT_TEMPLATES_START';
const EDIT_TEMPLATES_ERROR = 'EDIT_TEMPLATES_ERROR';
const EDIT_TEMPLATES_SUCCESS = 'EDIT_TEMPLATES_SUCCESS';
const DELETE_TEMPLATES_START = 'DELETE_TEMPLATES_START';
const DELETE_TEMPLATES_ERROR = 'DELETE_TEMPLATES_ERROR';
const DELETE_TEMPLATES_SUCCESS = 'DELETE_TEMPLATES_SUCCESS';

export const annotationsReducer = (
  state: AnnotationsState,
  action: GlobalAction
): AnnotationsState => {
  const { payload, type } = action;

  switch (type) {
    case GET_ANNOTATIONS_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_ANNOTATIONS_ERROR:
    case ADD_ANNOTATIONS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_ANNOTATIONS_SUCCESS: {
      return {
        ...state,
        annotations: {
          ...state.annotations,
          [payload.videoId]: keyBy(payload.annotations, 'annotationId'),
        },
        companyAnnotations: {
          ...state.companyAnnotations,
          [payload.customerId]: keyBy(
            payload.companyAnnotations,
            'annotationId'
          ),
        },
        loading: false,
      };
    }
    case ADD_ANNOTATIONS_SUCCESS:
    case EDIT_ANNOTATIONS_SUCCESS: {
      const isCompanyAnnotation = !!payload.customerId;
      const copyState = { ...state };
      if (isCompanyAnnotation) {
        copyState.companyAnnotations = {
          ...copyState.companyAnnotations,
          [payload.customerId]: {
            ...copyState.companyAnnotations[payload.customerId],
            [payload.annotation.annotationId]: payload.annotation,
          },
        };
      } else {
        copyState.annotations = {
          ...state.annotations,
          [payload.videoId]: {
            ...state.annotations[payload.videoId],
            [payload.annotation.annotationId]: payload.annotation,
          },
        };
      }
      return {
        ...copyState,
      };
    }
    case DELETE_ANNOTATIONS_SUCCESS: {
      const { videoId, annotationId, customerId } = payload;
      const copyState = { ...state };

      if (customerId)
        delete copyState.companyAnnotations[customerId][annotationId];
      else delete copyState.annotations[videoId][annotationId];
      return copyState;
    }
    case GET_TEMPLATES_SUCCESS: {
      return {
        ...state,
        templates: keyBy(payload.templates, 'templateId'),
      };
    }
    case ADD_TEMPLATES_SUCCESS:
    case EDIT_TEMPLATES_SUCCESS: {
      return {
        ...state,
        templates: {
          ...state.templates,
          [payload.template.templateId]: payload.template,
        },
      };
    }
    case DELETE_TEMPLATES_SUCCESS: {
      const { templateId } = payload;
      const copyState = { ...state };
      delete copyState.templates[templateId];
      return copyState;
    }
    default:
      return state;
  }
};

export const ANNOTATIONS_ACTIONS = {
  GET_ANNOTATIONS_START,
  GET_ANNOTATIONS_ERROR,
  GET_ANNOTATIONS_SUCCESS,
  ADD_ANNOTATIONS_START,
  ADD_ANNOTATIONS_ERROR,
  ADD_ANNOTATIONS_SUCCESS,
  EDIT_ANNOTATIONS_START,
  EDIT_ANNOTATIONS_ERROR,
  EDIT_ANNOTATIONS_SUCCESS,
  DELETE_ANNOTATIONS_START,
  DELETE_ANNOTATIONS_ERROR,
  DELETE_ANNOTATIONS_SUCCESS,
  GET_TEMPLATES_START,
  GET_TEMPLATES_ERROR,
  GET_TEMPLATES_SUCCESS,
  ADD_TEMPLATES_START,
  ADD_TEMPLATES_ERROR,
  ADD_TEMPLATES_SUCCESS,
  EDIT_TEMPLATES_START,
  EDIT_TEMPLATES_ERROR,
  EDIT_TEMPLATES_SUCCESS,
  DELETE_TEMPLATES_START,
  DELETE_TEMPLATES_ERROR,
  DELETE_TEMPLATES_SUCCESS,
};
